import { Component, OnInit, OnDestroy } from '@angular/core';
import { ErrorService } from './share/services/error.service';
import { ModalConfig } from './share/models/modal-config.model';
import { TipoAlerta } from './share/enum/enumTipoAlerta';
import { AccionBoton } from './share/enum/enumAccionBoton';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'AgavalVinculacionWeb';
  private onlineHandler = () => console.log('✅ Conexión a internet restaurada');
  private offlineHandler = () => {
    console.log('❌ Conexión a internet perdida');
    this.mostrarModalSinInternet();
  };

  constructor(private errorService: ErrorService) {}

  ngOnInit(): void {
    window.addEventListener('online', this.onlineHandler);
    window.addEventListener('offline', this.offlineHandler);
    console.log('Estado inicial de conexión:', navigator.onLine ? '✅ Conectado' : '❌ Desconectado');
    
    if (!navigator.onLine) {
      this.mostrarModalSinInternet();
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('online', this.onlineHandler);
    window.removeEventListener('offline', this.offlineHandler);
  }

  private mostrarModalSinInternet(): void {
    const config: ModalConfig = {
      mensaje: '¡Ups! Parece que hay un problema con tu conexión ⚠️ No hemos podido establecer comunicación. Por favor, revisa tu conexión a internet y vuelve a intentarlo.',
      tipoAlerta: TipoAlerta.Advertencia,
      labelBotonPrimario: 'Entendido',
      accionBotonPrimario: AccionBoton.Cerrar
    };
    this.errorService.mostrarModal(config);
  }
}